//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const DSBridge = require('@/libs/ds-bridge')
const Utils = require('@/utils')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_RefereeMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_RefereeMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_RefereeMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
        // console.log('handleCreationComplete')
        const organizationId = this._bridge.getRouteQuery('organizationId')
        if (!this._bridge.isCreate()) {
            if (this._bridge.isList()) {
                this.creationComplete({parameters: {organizationId: organizationId}})
            }
            else {
                this.creationComplete()
            }
        }
        else {
            this.target().matchId = this._bridge.getRouteQuery('matchId')
        }
        if (this._bridge.isList()) {
            // set the organization id via the route query
            this.target().organizationId = organizationId
        }
        else {
            this.target().referee.organizationId = organizationId
        }
    },
    /**
     * @api
     * Handle the customized event condition triggered by 
     * the scene instance.
     * @event The event object contains 
     * {type:String, data:Object, target:VueComponent}
     */
    handleCustomizedEvent: function(event) {
        if (event.type == 'invite-referee') {
            this.sendRefereeInvite(event.data, this.convertor())
        }
        else {
            return true
        }
    },
    handleRouteBack: function() {
        if (this._bridge.getRouteName() == 'OrgListReferee') {
            this._bridge.goToScene('OrgManageOrganization', {id: this._bridge.getRouteQuery('organizationId')})
        }
        else {
            this._bridge.back()
        }
    },
    handleRemoveService: function() {
        const from = this._bridge.getRouteQuery('from')
        if (from == 'OrgListMatchReferee') {
            this._bridge.goToScene(from, {id: this._bridge.getRouteQuery('matchId')}, {organizationId: this.target().referee.organizationId})
        }
        else {
            this._bridge.goToScene('OrgListReferee', {}, {organizationId: this.target().referee.organizationId})
        }
    },
    sendRefereeInvite: function(data, convertor) {
        console.log('sendRefereeInvite', data, convertor)
        const self = this
        self.loadViewObjectData(convertor, {id: data.id}, function(data) {
            console.log('load referee data', data)
            const startIndex = location.href.indexOf('/org')
            const link = location.href.substr(0, startIndex) + '/org/referee/invite/' + data.id    
            const shareParam = {
                title: convertor.localeProp('member-invite-title', {name: data.name, role: data.role}),
                desc: data.organizationName,
                imgUrl: Utils.QNImageUtil.imageView(data.organizationLogoUrl, 360, 360),
                link: link
            }
            console.log('share link', shareParam)
            DSBridge.callShare(shareParam)
        }, 'invite')
    },
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_RefereeMediator, BaseMediator);

module.exports = tbs_controller_RefereeMediator